/**
 * Text formatting shared by the web app and the matchup report builder, so a
 * score or record reads the same in a computed fact as on the page.
 */

/** Points as shown on Yahoo: always two decimals. */
export function formatPoints(points: number): string {
  return points.toFixed(2);
}

/** Win-loss record with an en dash, e.g. "3–0"; ties only appear when there are any ("3–0–1"). */
export function formatRecord(wins: number, losses: number, ties = 0): string {
  return ties > 0 ? `${wins}–${losses}–${ties}` : `${wins}–${losses}`;
}

/** 1st, 2nd, 3rd, 4th, ..., 11th, 12th, 13th, ..., 21st. */
export function ordinal(n: number): string {
  const lastTwo = n % 100;
  const suffix = lastTwo >= 11 && lastTwo <= 13 ? "th" : ({ 1: "st", 2: "nd", 3: "rd" } as Record<number, string>)[n % 10] ?? "th";
  return `${n}${suffix}`;
}
